import { KYMW1600Model } from '../kymw1600.model';
import { GetImageInfoModel } from '../vo/get-image-info.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 画像情報取得要求サービス
 *
 * @export GetImageInfoService
 * @class GetImageInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetImageInfoService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1300Model}
   * @memberof GetImageInfoService
   */
  private model: KYMW1600Model;

  /**
   * 処理に使用するVO
   *
   * @private
   * @type {Object}
   * @memberof GetImageInfoService
   */
  private vo: GetImageInfoModel;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetImageInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        PCodeList: this.vo.pcodeList,
        GuideGoodsName: this.vo.guideGoodsName,
        GuideStandardName: this.vo.guideStandardName,
        ImageName: this.vo.imageName,
        ImageFileName: this.vo.imageFileName,
        ImageBelongId: this.vo.imageBelongId,
        ImageKind: this.vo.imageKind,
        ImageType: this.vo.imageType,
        ProcessInstruct: this.vo.processInstruct,
        RemarksList: this.vo.remarksList,
        CookingExPublish: this.vo.cookingExPublish,
        CookingDiv: this.vo.cookingDiv,
        CookingNameList: this.vo.cookingNameList,
        MaterialNameList: this.vo.materialNameList,
        KeyWordList: this.vo.keyWordList,
        EventId: this.vo.eventId,
        PhotoContentsDiv: this.vo.photoContentsDiv,
        PhotoStudioId: this.vo.photoStudioId,
        ImageInstructUserId: this.vo.imageInstructUserId,
        ImageInstructDateFrom: this.vo.imageInstructDateFrom,
        ImageInstructDateTo: this.vo.imageInstructDateTo,
        FileRegistDateFrom: this.vo.fileRegistDateFrom,
        FileRegistDateTo: this.vo.fileRegistDateTo,
        Status: this.vo.status,
        ImageInstruct: this.vo.imageInstruct,
        Enabled: this.vo.enabled,
        PhotoScheduleFrom: this.vo.photoScheduleFrom,
        PhotoScheduleTo: this.vo.photoScheduleTo,
        ClassCode: this.vo.classCode,
        MultipleCode: this.vo.multipleCode,
        StartOrderCode: this.vo.startOrderCode,
        StartDelivCatalogId: this.vo.startDelivCatalogId,
        BillingName: this.vo.billingName,
        BuyerCode: this.vo.buyerCode,
        OutputFlg: this.vo.outputFlg,
        CarriedForward: this.vo.carriedForward,
        C2pfTarget: this.vo.c2pfTarget,
        PhotographingChangeSchedule: this.vo.photographingChangeSchedule
      }
});
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetImageInfoService
   */
  execute(model: KYMW1600Model, vo: GetImageInfoModel): void {
    this.model = model;
    this.vo = vo;
    this.send('KYMW16GetImageInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetImageInfoService
   */
  success(data: any): void {
    this.model.updateImageInfoList(data);
  }
}
